import angular from 'angular'

import Emitter from '../utils/emitter'
import MapSimple from '../utils/map-simple'
import debugFields from '../utils/debug-fields'
import extractRawElm from '../utils/extract-raw-elm'

import { before, after } from '../utils/bits'
import { offEvent, onEventPassive } from '../utils/on-event'
import { getElmStr, getElmStrShort } from '../utils/get-elm-str'

angular
  .module('ggs.element-position')
  .factory('DisplayDetector', DisplayDetectorProvider)

const ANIMATION_NAME = 'animation-name'
const ANIMATION_START = 'animationstart'

function DisplayDetectorProvider(
  domh,
  rootQs,
  $rootScope,
  addIdPrefix) {

  const cache = MapSimple()
  const marker = addIdPrefix('display-detector')
  const style = domh.createStyle(marker).attach().global(`
    @keyframes ${marker} {
      0% { visibility: inherit; }
    }
    ${rootQs}[${marker}], ${rootQs} [${marker}] {
      animation: 1ms ${marker};
    }`)

  $rootScope.$on('$destroy', onDestroy)

  return debugFields(DisplayDetector, {
    _style: style,
    _cache: cache,
    _marker: marker
  })

  function onDestroy() {
    style.detach()
  }

  function DisplayDetector($elm) {
    const elm = extractRawElm($elm)

    if (cache.has(elm)) {
      return cache.get(elm)
    }

    elm.setAttribute(marker, true)

    let destroyed = false
    const detector = cache.set(elm, Emitter(`displayDetector[elm=${getElmStrShort(elm)}]`))

    detector.on = before(beforeOn, detector.on)
    detector.pre = before(beforeOn, detector.pre)
    detector.after = before(beforeOn, detector.after)
    detector.off = after(detector.off, afterOff)
    detector.clear = after(detector.clear, afterOff)

    debugFields(detector, {
      _elm: elm,
      _handler: handler,
      _destroyed: () => destroyed
    })

    return detector

    function handler(event) {
      const elm = event.target
      let animationName = null
      if (event.animationName) {
        animationName = event.animationName
      } else {
        const styles = elm && window.getComputedStyle(elm)
        animationName = styles && styles.getPropertyValue(ANIMATION_NAME)
      }

      const isDisplayed = animationName && (-1 !== animationName.indexOf(marker))
      if (isDisplayed) {
        detector.emit()
      }
    }

    function beforeOn() {
      if (destroyed) {
        throw new Error(`DisplayDetector: already destroyed! ${getElmStr(elm)}`)
      }

      if (detector.size() === 0) {
        onEventPassive(elm, ANIMATION_START, handler)
      }
    }

    function afterOff() {
      if (!destroyed && detector.size() === 0) {
        offEvent(elm, ANIMATION_START, handler)
        cache.del(elm)
        destroyed = true
      }
    }
  }
}
